import React from 'react';
import { Link } from 'react-router-dom';

const FeaturedCollections: React.FC = () => {
  const collections = [
    {
      id: 'suits',
      name: 'Suits',
      description: 'Tailored formal wear for the boardroom and beyond.',
      image: '/images/collection/suits.jpg',
      category: 'Formal',
    },
    {
      id: 'jerseys',
      name: 'Football Jerseys',
      description: 'Match-day jerseys and club wear built for performance.',
      image: '/images/collection/jersey.webp',
      category: 'Sport',
    },
    {
      id: 'kits',
      name: 'Training Kits',
      description: 'Performance kits and sportswear for training and casual wear.',
      image: '/images/collection/kits.jpeg',
      category: 'Performance',
    },
  ];

  return (
    <section className="py-20 lg:py-28 bg-slate-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <h2 className="font-display text-3xl md:text-4xl font-semibold text-slate-900 tracking-tight">
              Featured collections
            </h2>
            <p className="mt-2 text-slate-600">
              Suits, jerseys, and kits — built for performance and style.
            </p>
          </div>
          <Link
            to="/collections"
            className="text-sm font-medium text-slate-900 hover:underline underline-offset-4 shrink-0"
          >
            View all →
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {collections.map((c) => (
            <Link
              key={c.id}
              to={`/collections#${c.id}`}
              className="group group block bg-white rounded-2xl overflow-hidden border border-slate-100 hover:border-slate-200 hover:shadow-lg transition-all duration-300"
            >
              <div className="aspect-[4/5] overflow-hidden bg-slate-100">
                <img
                  src={c.image}
                  alt={c.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <span className="text-xs font-medium uppercase tracking-wider text-slate-500">
                  {c.category}
                </span>
                <h3 className="mt-2 font-display font-semibold text-slate-900 text-xl">
                  {c.name}
                </h3>
                <p className="mt-2 text-sm text-slate-600">
                  {c.description}
                </p>
                <span className="mt-4 inline-flex items-center text-sm font-medium text-slate-900 group-hover:underline">
                  Explore
                  <svg className="ml-1 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                  </svg>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedCollections;
